__turbopack_context__.v({
  "className": "jetbrains_mono_17b0ffb2-module__Wav3qW__className",
  "variable": "jetbrains_mono_17b0ffb2-module__Wav3qW__variable",
});
